import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
export function Column({ className, children, sticky = false }) {
    return (_jsx("div", { className: clsx(className, '[&>:first-child]:mt-0 [&>:last-child]:mb-0', sticky && 'md:sticky md:top-24'), children: children }));
}
export function ColumnLayout({ children }) {
    return _jsx("div", { className: "grid grid-cols-1 items-start gap-x-16 gap-y-10 md:max-w-none md:grid-cols-2", children: children });
}
